import LoginForm from './LoginForm.component';

export default LoginForm;
